import { z } from 'zod';

export const searchTrainingsSchema = z.object({
  query: z.string().min(1, 'Search query is required'),
  limit: z
    .string()
    .optional()
    .default('20')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export type SearchTrainingsPayload = z.infer<typeof searchTrainingsSchema>;
